import { InteracTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchInteracMoneyRequestTransaction({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);

  const [interacMoneyRequestTransaction, setInteracMoneyRequestTransaction] = useState<InteracTransaction>();

  async function fetchInteracMoneyRequestTransaction(transactionID: string) {
    try {
      setFetching(true);
      const res = await api.fetchInteracMoneyRequestTransaction({ TransactionID: transactionID }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setInteracMoneyRequestTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, interacMoneyRequestTransaction, fetchInteracMoneyRequestTransaction };
}
